<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useSmartCampaignsStore } from 'dashboard/stores/smartCampaigns';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const store = useSmartCampaignsStore();
const dialogRef = ref(null);

const handleConfirm = async () => {
  if (!props.selectedCampaign?.id) return;

  try {
    await store.delete(props.selectedCampaign.id);
    useAlert(t('SMART_CAMPAIGNS.CONFIRM_DELETE.API.SUCCESS_MESSAGE'));
  } catch {
    useAlert(t('SMART_CAMPAIGNS.CONFIRM_DELETE.API.ERROR_MESSAGE'));
  } finally {
    dialogRef.value?.close();
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('SMART_CAMPAIGNS.CONFIRM_DELETE.TITLE')"
    :description="t('SMART_CAMPAIGNS.CONFIRM_DELETE.DESCRIPTION')"
    :confirm-button-label="t('SMART_CAMPAIGNS.CONFIRM_DELETE.CONFIRM')"
    @confirm="handleConfirm"
  />
</template>
